import axiosInstance, { axiosCacheInstance } from '../../../axiosSetup';

export type DropOffContainer = {
  blContainerId?: number | null;
  containerPickupId?: number | null;
  containerNo: string;
  returnDate?: string | null;
};

export type AttachmentConfig = {
  docId: number;
  docName: string;
  isMandatory?: string;
};

export const fetchDropOffAttachmentConfig = async (
  country: string,
  linerId: string | number
): Promise<AttachmentConfig[]> => {
  const response = await axiosCacheInstance.get(
    `/api/edo-rest-v2/v2/common/attachments?countryCode=${country}&linerId=${linerId}&instructionType=824`,
    { cache: { ttl: 10 * 60 * 1000 } }
  );
  return response.data ?? [];
};

export const submitContainerDropOff = async (payload: any) => {
  const response = await axiosInstance.post(
    '/api/edo-rest-v2/v2/dndInstruction/submitDeliveryOrderReq',
    {
      ...payload,
      instructionType: 824,
    }
  );
  return response.data;
};
